'use client';

import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { Tooltip } from '@repo/design-system/components/ds/tooltip/tooltip';
import { DropdownMenu } from '@repo/design-system/components/ui/dropdown-menu';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useLayerControl } from './hooks/useLayerControl';
import { LayerControlMenuItems } from './layer-control-menu-items';
export const CompactLayerButton = () => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    hasAnyLayerOption
  } = useLayerControl();
  if (!hasAnyLayerOption) {
    return null;
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      borderRadius: "full",
      "&:not(:focus-visible)": {
        boxShadow: "lg"
      }
    });
    t4 = <Icon icon="layers" decorative={true} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = <IconButton color="white" size="lg" aria-label={t2} className={t3}>{t4}</IconButton>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LayerControlMenuItems />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <DropdownMenu variant="dark" placement="top-end" offset={8} closeOnSelect={false} trigger={t5}>{t6}</DropdownMenu>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <Tooltip content={t1} offset={8} placement="left" size="md">{t7}</Tooltip>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp($) {
  return $.layer_controls;
}
function _temp2($_0) {
  return $_0.layer_controls;
}